import { ApplicationConfig, importProvidersFrom, isDevMode } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ServiceWorkerModule } from "@angular/service-worker";
import { APP_ROUTES } from "./app.routes";
import { provideAuth } from "./core/config/auth.config";
import { provideCustomIcons } from "./core/providers/icon.provider";
import { provideNgRx } from "./core/providers/ngrx.provider";
import { provideSnackbarDefaults } from "./shared/services/snackbar.service";
import { FetchInterceptorService } from "./core/interceptors/fetch-interceptor.service";
import { DatabaseTileService } from "./shared/services/indexed-db/indexed-db-tile.service";

/**
 * Application configuration for the IGV iGrid Visualization application.
 * Centralizes all providers and configuration for the Angular application.
 *
 * @see https://angular.dev/guide/standalone-components#configuring-dependency-injection
 */
export const appConfig: ApplicationConfig = {
  providers: [
    // Router configuration
    provideRouter(APP_ROUTES),

    // Authentication
    provideAuth(),

    // HTTP Client with interceptors
    provideHttpClient(withInterceptorsFromDi()),

    // Animations
    provideAnimations(),

    // Custom SVG icons
    provideCustomIcons(),

    // Snackbar defaults
    provideSnackbarDefaults(),

    // NgRx state management
    provideNgRx(),

    // Service Worker
    importProvidersFrom(
      ServiceWorkerModule.register("ngsw-worker.js", {
        enabled: !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: "registerWhenStable:30000",
      })
    ),

    // Core services
    FetchInterceptorService,
    DatabaseTileService,
  ],
};
